/**
 * HEADER REDUX REDUCERS
 *
 * @version 0.1
 */

import {
    UPDATE_HEADER,
    UPDATE_HELP_URL
} from './Header.actions';

const headerOptions = {
    getStartedNewUser:                {
        menuStateClass: 'getStarted',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.getStarted',
        helpUrl:        'firstimedashboardtips-field?lbu=US&locale=en_US&audience=all'
    },
    getStartedReturningUser:          {
        menuStateClass: 'getStarted',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.getStarted',
        helpUrl:        'getstarteddashboardtips-field?lbu=US&locale=en_US&audience=all'
    },
    getStartedDashboard:              {
        menuStateClass: '',
        subMenuMessage: '',
        helpUrl:        'getstarteddashboardtips-field?lbu=US&locale=en_US&audience=all'
    },
    getStartedDashboardEntityProfile: {
        menuStateClass: '',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.getStartedEntityProfile',
        helpUrl:        'aboutentitytips-field?lbu=US&locale=en_US&audience=all'
    },
    batchUpload:                      {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.batchUpload',
        helpUrl:        'batchuploadtips-field?lbu=US&locale=en_US&audience=all'
    },
    checkFormatting:                  {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.checkFormatting',
        helpUrl:        'checkformattingtips-field?lbu=US&locale=en_US&audience=all'
    },
    fileReadingError:                 {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.fileReadingError',
        helpUrl:        'filereadingerrortips-field?lbu=US&locale=en_US&audience=all'
    },
    // to-do: need help url for cap exceeded, add us + gb i18n for submenu text
    subscriptionPlanExceeded:         {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.subscriptionPlanExceeded',
        helpUrl:        'filereadingerrortips-field?lbu=US&locale=en_US&audience=all'
    },
    reviewCompanies:                  {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.reviewCompanies',
        helpUrl:        'reviewcompaniestips-field?lbu=US&locale=en_US&audience=all'
    },
    //extends reviewCompanies
    thirdPartyListing:                {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.thirdPartyListing',
        helpUrl:        'managecompaniestips-field?lbu=US&locale=en_US&audience=all'
    },
    previewCompany:                   {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.previewCompany',
        helpUrl:        'previewresultstips-field?lbu=US&locale=en_US&audience=all'
    },
    previewArticle:                   {
        menuStateClass: 'uploads',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.previewCompany',
        helpUrl:        'previewnewstips-field?lbu=US&locale=en_US&audience=all'
    },
    previewArticleFromEdit:           {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.previewCompany',
        helpUrl:        'previewnewstips-field?lbu=US&locale=en_US&audience=all'
    },
    editThirdParty:                   {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.editThirdParty',
        helpUrl:        'editcompanytips-field?lbu=US&locale=en_US&audience=all'
    },
    createNewEntity:                  {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.createNewEntity',
        helpUrl:        'createsingleentitytips-field?lbu=US&locale=en_US&audience=all'
    },
    manageCategories:                  {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.manageAllCategories',
        helpUrl:        'managecategorytips-field?lbu=US&locale=en_US&audience=all'
    },
    createNewCategory:                  {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.createNewCategory',
        helpUrl:        'addcategorytips-field?lbu=US&locale=en_US&audience=all'
    },
    editCategory:                  {
        menuStateClass: 'companies',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.editCategory',
        helpUrl:        'addcategorytips-field-field?lbu=US&locale=en_US&audience=all'
    },
    feedListing:                      {
        menuStateClass: 'feeds',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.feedListing',
        helpUrl:        'managersstips-field?lbu=US&locale=en_US&audience=all'
    },
    viewFeedContent:                  {
        menuStateClass: '',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.viewFeedContent',
        helpUrl:        'viewrssfeed_hdi-task?lbu=US&locale=en_US&audience=all'
    },
    createNewAlert:                   {
        menuStateClass: 'alerts',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.createNewAlert',
        helpUrl:        'alertscreatenewtips-field?lbu=US&locale=en_US&audience=all'
    },
    editAlert:                        {
        menuStateClass: 'alerts',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.editAlert',
        helpUrl:        'alertsedittips-field?lbu=US&locale=en_US&audience=all'
    },
    addRssFeed:                       {
        menuStateClass: 'feeds',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.createNewRssFeed',
        helpUrl:        'addrsstips-field?lbu=US&locale=en_US&audience=all'
    },
    editFeed:                         {
        menuStateClass: 'feeds',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.editFeed',
        helpUrl:        'editrssfeedtips-field?lbu=US&locale=en_US&audience=all'
    },
    manageEmailAlerts: {
        menuStateClass: 'alerts',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.manageEmailAlerts',
        helpUrl:        'alertsmanagetips-field?lbu=US&locale=en_US&audience=all'
    },
    experianReportPage: {
        menuStateClass: '',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.experianReportPage',
        helpUrl:        'experiantips-field?lbu=US&locale=en_US&audience=all'
    },
    errorPage500:                     {
        menuStateClass: 'error500',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.error500',
        helpUrl:        'getstarteddashboardtips-field?lbu=US&locale=en_US&audience=all'
    },
    errorPage404:                     {
        menuStateClass: 'error404',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.error404',
        helpUrl:        'getstarteddashboardtips-field?lbu=US&locale=en_US&audience=all'
    },
    adminPage: {
        menuStateClass: 'adminPage',
        subMenuMessage: 'HeaderFooterNav_SubMenu_UIText_subMenu.adminPage',
        helpUrl:        'adminpaneltips-field?lbu=US&locale=en_US&audience=all'
    },
    logOut:                           {
        menuStateClass: '',
        subMenuMessage: '',
        helpUrl:        'home?lbu=US&locale=en_US&audience=all'
    },
    emptySubMenu:                     {
        menuStateClass: '',
        subMenuMessage: '',
        helpUrl:        'home?lbu=US&locale=en_US&audience=all'
    },

    // This entry is for displaying an empty submenu
    emptySubMenuVisible: {
        menuStateClass: '',
        subMenuMessage: ' ',
        helpUrl:        'home?lbu=US&locale=en_US&audience=all'
    }
};

function updateHeader(state = null, action) {

    switch (action.type) {
        case UPDATE_HEADER:
            if (typeof action.payload === "string") {
                return Object.assign({}, state, headerOptions[action.payload]);
            } else {
                return Object.assign({}, state, action.payload);
            }

        case UPDATE_HELP_URL:
            return Object.assign({}, state, {helpUrl: action.payload});

        case "SET_VERSION":
            return Object.assign({}, state, {version: action.payload});

        default:
            return state;

    }

}

export default updateHeader;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/Header.reducers.js